import { render, staticRenderFns } from "./SyaratKetentuan.vue?vue&type=template&id=746db77a&scoped=true&"
import script from "./SyaratKetentuan.vue?vue&type=script&lang=js&"
export * from "./SyaratKetentuan.vue?vue&type=script&lang=js&"
import style0 from "./SyaratKetentuan.vue?vue&type=style&index=0&id=746db77a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746db77a",
  null
  
)

export default component.exports